import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { BackendApiService } from 'src/app/service/backend-api.service';

const FAMILLES_METIERS = [
  { name: 'DÉVELOPPEMENT LOGICIEL', shortName: 'Dev logiciel' },
  {
    name: 'TECHNOLOGIES ÉMERGENTES ET SÉCURITÉ NUMÉRIQUE',
    shortName: 'Techno emergent',
  },
  { name: 'INTELLIGENCE ARTIFICIELLE & DONNÉES', shortName: 'IA & Données' },
  { name: 'CRÉATION DE CONTENU AUDIOVISUELS ANIMES', shortName: 'CCAA' },
  { name: 'E-BUSINESS', shortName: 'E-bus' },
];
@Component({
  selector: 'app-candidatures',
  templateUrl: './candidatures.component.html',
  styleUrls: ['./candidatures.component.css'],
})
export class CandidaturesComponent implements OnInit {
  form!: FormGroup;
  getEligibilityCriteriaControls(): any {
    return (this.form.get('familyMetierDTOList') as FormArray).controls;
  }
  famillesMetiers = FAMILLES_METIERS;
  showConfirmModal = false;

  isEditMode = false;
  applicationId: number | null = null;
  showSuccessModal = false;

  constructor(
    private formBuilder: FormBuilder,
    private backendApiService: BackendApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    // Initialisez le formulaire avec des champs vides et des validateurs si nécessaire
    this.form = this.formBuilder.group({
      applicationStatus: ['En Cours'],
      applicationName: ['', Validators.required],
      applicationType: ['CERTIFICAT', Validators.required],
      applicationInformations: [''],
      openDate: [null, Validators.required],
      closeDate: [null, Validators.required],
      familyMetierDTOList: this.formBuilder.array([
        this.initEligibilityCriteria(),
      ]),
    });
  }
  // Initialisez un groupe pour les critères d'éligibilité avec un seul ensemble de règles (famille de métier)
  initEligibilityCriteria() {
    return this.formBuilder.group({
      name: ['', Validators.required],
      prerequisite: this.formBuilder.array([this.initRule()]),
    });
  }
  // Initialisez un groupe pour les règles (prerequis)
  initRule() {
    return this.formBuilder.group({
      name: ['', Validators.required],
      markPrereq: [0, Validators.required],
    });
  }
  // Ajoutez un ensemble de critères d'éligibilité au formulaire
  addEligibilityCriteria() {
    const control = this.form.get('familyMetierDTOList') as FormArray;
    control.push(this.initEligibilityCriteria());
    //// //console.log(control.length)
  }
  // Supprimez un ensemble de critères d'éligibilité du formulaire
  removeEligibilityCriteria(index: number) {
    const control = this.form.get('familyMetierDTOList') as FormArray;
    control.removeAt(index);
  }
  // Pour actionner le vrai bouton afin de "Supprimez un ensemble de critères d'éligibilité du formulaire"
  @ViewChild('realBtn') realBtn!: ElementRef<HTMLElement>;
  triggerClickRealBtn() {
    let el: HTMLElement = this.realBtn.nativeElement;
    el.click();
  }
  // Ajoutez un ensemble de règles à un ensemble de critères d'éligibilité
  addRule(eligibilityCriteriaIndex: number) {
    const control = (this.form.get('familyMetierDTOList') as FormArray)
      .at(eligibilityCriteriaIndex)
      .get('prerequisite') as FormArray;
    control.push(this.initRule());
  }
  // Supprimez un ensemble de règles d'un ensemble de critères d'éligibilité
  removeRule(eligibilityCriteriaIndex: number, ruleIndex: number) {
    const control = (this.form.get('familyMetierDTOList') as FormArray)
      .at(eligibilityCriteriaIndex)
      .get('prerequisite') as FormArray;
    control.removeAt(ruleIndex);
  }

 openConfirmModal() {
  console.log('Form valid?', this.form.valid);
  console.log('Form value:', this.form.value);

  const familyArray = this.form.get('familyMetierDTOList') as FormArray;
  familyArray.controls.forEach((familyGroup, i) => {
    if (familyGroup.invalid) {
      console.log(`Famille ${i} invalide:`, familyGroup.errors);
      const prereqArray = familyGroup.get('prerequisite') as FormArray;
      prereqArray.controls.forEach((rule, j) => {
        if (rule.invalid) {
          console.log(`  Prérequis ${j} invalide:`, rule.value, rule.errors);
        }
      });
    }
  });

  if (this.form.valid) {
    this.showConfirmModal = true;
  } else {
    this.form.markAllAsTouched();
    console.log('Formulaire invalide, blocage.');
  }
}
  // Soumettez le formulaire
  confirmSubmit() {
  this.showConfirmModal = false;

  if (!this.form.valid) {
    return;
  }

  if (this.isEditMode && this.applicationId) {
    const payload = this.buildPartialPayload();

    this.backendApiService.updateApplication(this.applicationId, payload).subscribe(
      (response: any) => {
        this.showSuccessModal = true;
      },
      (error: any) => {
        console.error('Erreur lors de la mise à jour :', error);
      },
    );
    return;
  }

  const payload = { ...this.form.value };
  payload.familyMetierDTOList = payload.familyMetierDTOList.map(
    (famille: any) => {
      const correspondance = this.famillesMetiers.find(
        (f) => f.name === famille.name,
      );
      return {
        ...famille,
        shortName: correspondance ? correspondance.shortName : '',
      };
    },
  );

  this.backendApiService.addApplication(payload).subscribe(
    (response: any) => {
      this.form.reset();
      this.showSuccessModal = true;
    },
    (error: any) => {
      console.error('Erreur lors de l\'ajout des données :', error);
    },
  );
}

closeSuccessModal(): void {
  this.showSuccessModal = false;
  this.router.navigate(['dashboard', 'appels', 'listAppels'], {
    queryParams: { type: 'parcours' },
  });
}
  
 private buildPartialPayload(): any {
  const payload: any = {};
  const controls = this.form.controls;

  Object.keys(controls).forEach((key) => {
    const control = controls[key];

    if (key === 'familyMetierDTOList') {
      payload[key] = (control.value as any[]).map((famille: any) => {
        const correspondance = this.famillesMetiers.find(
          (f) => f.name === famille.name,
        );
        return {
          ...famille,
          shortName: correspondance ? correspondance.shortName : '',
        };
      });
      return;
    }

    if (control.dirty) {
      payload[key] = control.value;
    }
  });

  return payload;
}

  cancelSubmit() {
    this.showConfirmModal = false;
  }

  ngOnInit() {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.isEditMode = true;
      this.applicationId = +idParam;
      this.loadApplication(this.applicationId);
    }
  }

  private loadApplication(id: number): void {
    this.backendApiService.getApplicationById(id).subscribe({
      next: (app: any) => {
        this.form.patchValue({
          applicationStatus: app.applicationStatus,
          applicationName: app.applicationName,
          applicationType: app.applicationType,
          applicationInformations: app.applicationInformations,
          openDate: app.openDate,
          closeDate: app.closeDate,
        });
        this.form.get('openDate')?.disable();

        // Reconstruire le FormArray des familles de métiers
        if (app.familyMetierDTOList?.length) {
          const familyArray = this.form.get('familyMetierDTOList') as FormArray;
          familyArray.clear();
          app.familyMetierDTOList.forEach((famille: any) => {
            const familyGroup = this.initEligibilityCriteria();
            familyGroup.patchValue({ name: famille.name });
            const prereqArray = familyGroup.get('prerequisite') as FormArray;
            prereqArray.clear();
            (famille.prerequisite ?? famille.genericPrerequisiteList ?? []).forEach(
              (p: any) => {
                const ruleGroup = this.initRule();
                ruleGroup.patchValue({ name: p.name, markPrereq: p.markPrereq });
                prereqArray.push(ruleGroup);
              },
            );
            familyArray.push(familyGroup);
          });
        }

        // Après le patch initial, on marque le formulaire comme "propre"
        // pour ne détecter que les VRAIES modifications de l'utilisateur
        this.form.markAsPristine();
      },
      error: (err) => console.error('Erreur lors du chargement de l’appel:', err),
    });
  }
  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'SIGUI' },
    { label: 'GESTION DES APPELS', url: '/dashboard/appels/listAppels' },
    {
      label: 'APPEL À CANDIDATURES PARCOURS',
      url: '/dashboard/appels/candidature',
    },
  ];

  getShortName(index: number): string {
    const familyGroup = (this.form.get('familyMetierDTOList') as FormArray).at(
      index,
    );
    const selectedName = familyGroup.get('name')?.value;
    const correspondance = this.famillesMetiers.find(
      (f) => f.name === selectedName,
    );
    return correspondance ? correspondance.shortName : '';
  }
}
